export default __webpack_public_path__ + "static/media/light.62ef90d8.svg";